<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Страхование"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Страхование
        </div>
      </template>

      <v-data-table
        :headers="headers"
        :items="items"
        :footerProps="datatable_footer"
        show-expand
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                    @keyup.enter="load(false, 6)"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                    @keyup.enter="load(false, 6)"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="form.users"
                    multiple
                    label="Менеджер"
                    :items="select.user"
                    @change="load(false, 6)"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="form.insurers"
                    multiple
                    label="Страхования компания"
                    :items="select.insurer"
                    @change="load(false, 6)"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="form.products"
                    multiple
                    label="Страховой продукт"
                    :items="select.product"
                    @change="load(false, 6)"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="form.group"
                    label="Тип агрегрирования"
                    :items="select.group"
                    @change="load(false, 6)"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="150"
                    @click="load(false, 6)"
                  >
                    Показать
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="250"
                    @click="load(true, 6)"
                  >
                    Выгрузить отчет
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item.date="{item}">
          {{ format(item.date) }}
        </template>
        <template v-slot:expanded-item="{item, headers }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="12">
                <v-data-table
                  hide-default-footer
                  :items="item.data"
                  :headers="headers_detail"
                  disable-pagination
                  >
                </v-data-table>
              </v-col>  
            </v-row>
          </td>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      headers: [
        {
          text: 'Агрегируемый параметр',
          value: 'group',
        },
        {
          text: 'Количество оформленных полисов',
          value: 'count',
        },
        {
          text: 'Сумма страховых премий',
          value: 'sum',
        },
        {
          text: 'Сумма агентского вознаграждения',
          value: 'sum_agent',
        },        
      ],
      headers_detail: [
        {
          text: 'Наименование СК',
          value: 'insurer'
        },
        {
          text: 'ФИО менеджера',
          value: 'user'
        },
        {
          text: 'Страховой продукт',
          value: 'product'
        },
        {
          text: 'Количество оформленных полисов',
          value: 'count',
        },
        {
          text: 'Сумма страховых премий',
          value: 'sum',
        },
        {
          text: 'Сумма агентского вознаграждения',
          value: 'sum_agent',
        }, 
      ],
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
        group: 1
      },
      select: {
        insurer: [],
        user: [],
        product: [],
        group: [
          {
            value: 1, text: 'По менеджеру'
          },
          {
            value: 2, text: 'По страховой компании'
          },
          {
            value: 3, text: 'По страховому продукту'
          }
        ]
      },
      dict: {
        state: {
          1: 'Новый',
          2: 'Осмотр назначен',
          3: 'Осмотр проведен',
          4: 'Документы сданы в СК',
          5: 'Выплата согласована СК',
          6: 'Деньги получены от СК',
          7: 'Передано в архив',
          8: 'Удален',
          9: 'Ремонт завершен',
          10: 'Расторгнут'
        },
        kind: {
          1: 'Оформление документов',
          2: 'Договор Цессии',
        },
        type: {},
        product: {},
        insurer: {}
      },
    }),
    mounted: function () {
      this.axios.post('/api/user/get/', {})
        .then(response => {
          if (!response.data.error) {
            for (let x in response.data.data) {
              this.select.user.push({
                value: response.data.data[x].id,
                text: response.data.data[x].surname + ' ' + response.data.data[x].name + ' ' + response.data.data[x].patronymic,
              })
            }
          } else {
            this.$store.commit('snackbar', response.data.error || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      for (let x in this.$store.state.dict.insurance_product) {
        if (this.$store.state.dict.insurance_product[x].active == 1) {
          var insurer = {}
          for (let y in this.$store.state.dict.insurer) {
            if (this.$store.state.dict.insurer[y].key == this.$store.state.dict.insurance_product[x].insurer) {
              console.log(this.$store.state.dict.insurer[y].key, this.$store.state.dict.insurance_product[x].insurer)
              insurer.value = Number(y),
              insurer.name = this.$store.state.dict.insurer[y].name
              break;
            }
          }
          this.select.product.push({
            value: Number(x),
            text: this.$store.state.dict.insurance_product[x].name,
            color: this.$store.state.dict.insurance_product[x].color,
            insurer: insurer
          })
          this.dict.product[Number(x)] = this.$store.state.dict.insurance_product[x].name
        }
      }
      for (let x in this.$store.state.dict.insurer) {
        this.select.insurer.push({
          value: Number(x),
          text: this.$store.state.dict.insurer[x].name,
          eurocom: this.$store.state.dict.insurer[x].eurocom
        })
        this.dict.insurer[Number(x)] = this.$store.state.dict.insurer[x].name
      }
      this.load(false, 6)
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
    },
    methods: {
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      load: function (exp, number) {
        if (exp) {
          let form = $('<form>', {
            target: '_blank',
            action: '/api/report/' + number,
            method: 'post',
          })
          form.append(
            $('<input>', {
              type: 'hidden',
              value: JSON.stringify(this.form),
              name: 'form',
            })
          )
          form.appendTo('body').submit()
        } else {
          this.axios.post('/api/report/show/' + number, this.form)
            .then(result => {
              if (!result.data.error) {
                this.items = result.data.data
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            })
        }
      },
    },
  }
</script>
